import { IPromise } from 'angular'
import { ApiCustomer, ApiResponse } from '@vend/types'

import { fetchApi } from '@vend/utilities'
import { $http } from '../../../ng-compat/imports'
import { extractData } from '../../../util/extract-data'
import { ApiCustomerTax } from '../../../factories/database/customer-taxes-store'

const CUSTOMERS_END_POINT = '/api/2.0/customers'
const CUSTOMER_TAX_END_POINT = '/api/2.0/customer_taxes'

/**
 * Functions for querying the customer API for customer data.
 */

/**
 * Get the given customer from the API.
 * @deprecated Use fetchCustomer instead for any non AngularJS code
 * @param  id
 *         The customer id which identifies the user to retrieve
 *
 * @return A promise resolved when the Customer object has been retrieved
 */
export function get(id: string): IPromise<ApiCustomer> {
  return $http
    .get<ApiResponse<ApiCustomer>>(`${CUSTOMERS_END_POINT}/${id}`)
    .then(extractData)
}

export function fetchCustomer(id: string): Promise<ApiCustomer> {
  return fetchApi(`${CUSTOMERS_END_POINT}/${id}`)
    .then(res => res.json())
    .then(data => data.data)
}

/**
 * Save the given customer to the API.
 *
 * @return A promise resolved with the final Customer object (including id, code, etc)
 *         from the server once the customer has been saved
 */
export function postCustomer(customer: ApiCustomer): Promise<ApiCustomer> {
  return fetchApi(CUSTOMERS_END_POINT, {
    method: 'POST',
    body: JSON.stringify(customer),
  })
    .then(res => res.json())
    .then(data => data.data)
}

/**
 * Update the given customer's details with the API.
 *
 * @param  customer
 *         The customer details to send to the server
 *
 * @return A promise resolved with the updated Customer object once the customer has
 *         been saved
 */
export function update(customer: ApiCustomer): IPromise<ApiCustomer> {
  return $http
    .put<ApiResponse<ApiCustomer>>(
      `${CUSTOMERS_END_POINT}/${customer.id}`,
      customer
    )
    .then(extractData)
}

/**
 * List customers from the API.
 *
 * @return A promise resolved when the Customer list has been retrieved
 */
export function list(): IPromise<ApiCustomer[]> {
  return $http
    .get<ApiResponse<ApiCustomer[]>>(CUSTOMERS_END_POINT)
    .then(extractData)
}

/**
 * Returns the tax override information for a customer
 */
export function fetchCustomerTax(id: string): Promise<ApiCustomerTax[]> {
  return fetchApi(`${CUSTOMER_TAX_END_POINT}?customer_id=${id}&deleted=true`)
    .then(res => res.json())
    .then(data => data.data)
}
